import React from 'react'
import { Input } from 'reactstrap'

interface MCCSearchInputProps {
  searchTerm: string
  onSearchChange: (value: string) => void
  disabled?: boolean
}

const MCCSearchInput: React.FC<MCCSearchInputProps> = ({
  searchTerm,
  onSearchChange,
  disabled = false,
}) => {
  return (
    <div className="p-2">
      <Input
        type="text"
        placeholder="Search by business type, category, or MCC code..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        className="mb-2"
        onClick={(e) => e.stopPropagation()}
        disabled={disabled}
      />
    </div>
  )
}

export default MCCSearchInput
